import React from "react"
import { View, StyleSheet, TouchableOpacity } from "react-native"
import { Theme } from "@theme"
import { useTheme } from "@react-navigation/native"
import { getCommonStyles, Scope } from "@utils"
import { Icon, Text } from "@components"

const ButtonSwipe = ({text, scope, isRight = false, onPress}: {text: string, scope?: Scope, isRight?: boolean, onPress?: () => void}) => {
  const theme = useTheme();
  const styles = getStyle(theme, scope);
  const commonStyles = getCommonStyles(theme);

  return (
    <TouchableOpacity style={[styles.row, !!scope && {paddingRight: isRight? undefined : theme.spacing.xxxl * 1.5, paddingLeft: isRight? theme.spacing.xxxl * 1.5: undefined}, isRight && {flexDirection: 'row-reverse'}, {backgroundColor: !!scope? (scope === Scope.PRIVATE? theme.colors.green: theme.colors.primary) : (isRight? theme.colors.primary : 'dimgray')}]} onPress={onPress}>
        <Icon name={isRight? 'arrowRight' : 'arrowLeft'} color={theme.colors.white}/>
        <Text type="body" color={theme.colors.white}>{text}</Text>
        {!!scope && <View style={[styles.scopeContainer, commonStyles.shadow, isRight? {left: -10} : {right: -10}]}><Icon name={scope === Scope.PRIVATE? 'lock' : 'work'} color={scope === Scope.PRIVATE? theme.colors.green: theme.colors.primary}/></View>}
    </TouchableOpacity>
  )
}

const getStyle = (theme: Theme, scope?: Scope) =>
    StyleSheet.create({
        row: {
            flexDirection: 'row',
            alignItems: 'center',
            alignSelf: 'center',
            paddingHorizontal: theme.spacing.lg,
            paddingVertical: theme.spacing.md,
            borderRadius: theme.iconSize.jumbo,
            gap: theme.spacing.lg
        },
        scopeContainer: {
            position: 'absolute',
            borderRadius: theme.iconSize.jumbo,
            backgroundColor: theme.colors.white,
            padding: theme.spacing.xs,
        }
    });

export default ButtonSwipe